{
  "name": "@363045841yyt/klinechart",
  "version": "0.5.6",
  "description": "A lightweight financial K-line charting library with first-class AI Agent support, crisp ResizeObserver-driven rendering, and plugin-based architecture. Focused on quantitative trading scenarios with TradingView-level interaction experience.",
  "author": "363045841 <slslswbsy@qq.com>",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/363045841/KLineChartQuant.git"
  },
  "bugs": "https://github.com/363045841/KLineChartQuant/issues",
  "homepage": "https://363045841.github.io/KLineChartQuant/",
  "keywords": [
    "kline-chart",
    "candlestick-chart",
    "financial-chart",
    "tradingview",
    "canvas",
    "rendering-engine",
    "resizeobserver",
    "device-pixel-content-box",
    "drawing-tools",
    "chart-drawing",
    "trend-line",
    "fibonacci",
    "high-performance",
    "pixel-perfect",
    "crisp-rendering",
    "sharp-rendering",
    "device-pixel-ratio",
    "responsive",
    "modern-ui",
    "agent",
    "ai-chart",
    "visualization",
    "quantitative-trading",
    "technical-analysis",
    "plugin-architecture",
    "typescript"
  ],
  "type": "module",
  "engines": {
    "node": "^20.19.0 || >=22.12.0"
  },
  "scripts": {
    "dev": "vite",
    "dev:lan": "vite --host 0.0.0.0",
    "stockbao": "cd .. && cd stockbao && uv run python ./server.py",
    "aktools": "cd .. && cd aktoolshttp && uv run python -m aktools",
    "build": "run-p type-check \"build-only {@}\" --",
    "build-only": "vite build",
    "build:demo": "vite build --config vite.demo.config.ts",
    "preview": "vite preview",
    "type-check": "vue-tsc --build",
    "test:unit": "vitest",
    "format": "prettier --write --experimental-cli src/",
    "prepublishOnly": "pnpm run build-only"
  },
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    },
    "./style.css": "./dist/klinechart.css"
  },
  "files": [
    "dist"
  ],
  "peerDependencies": {
    "vue": "^3.5.0"
  },
  "dependencies": {
    "ajv": "^8.20.0",
    "axios": "^1.16.0"
  },
  "devDependencies": {
    "@iconify-json/tabler": "^1.2.34",
    "@tsconfig/node24": "^24.0.4",
    "@types/jsdom": "^28.0.1",
    "@types/node": "^25.6.0",
    "@vitejs/plugin-vue": "^6.0.6",
    "@vitest/coverage-v8": "^4.1.5",
    "@vue/test-utils": "^2.4.10",
    "@vue/tsconfig": "^0.9.1",
    "jsdom": "^29.1.1",
    "npm-run-all2": "^8.0.4",
    "prettier": "3.8.3",
    "typedoc": "^0.28.19",
    "typescript": "~6.0.3",
    "unplugin-icons": "^23.0.1",
    "unplugin-vue-components": "^32.0.0",
    "vite": "^8.0.10",
    "vite-plugin-dts": "^4.5.4",
    "vite-plugin-vue-devtools": "^8.1.1",
    "vitest": "^4.1.5",
    "vue-tsc": "^3.2.8"
  }
}